module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-p-800-5932475d75ee0b9edaf0cf187252f77c.jpg";